import { render, staticRenderFns } from "./subAccountAdd.vue?vue&type=template&id=2012b50d&scoped=true&"
import script from "./subAccountAdd.vue?vue&type=script&lang=js&"
export * from "./subAccountAdd.vue?vue&type=script&lang=js&"
import style0 from "./subAccountAdd.vue?vue&type=style&index=0&id=2012b50d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012b50d",
  null
  
)

export default component.exports